import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAppContext } from "libs/contextLib";
import useUbaAuthToken from "./ubaToken";
import { useDispatch } from "react-redux";
import { setUbaToken } from "state/slices/ubaTokenSlice";

const AuthRedirect = () => {
  const location = useLocation();
  const { onAuthStateChange } = useAppContext();
  const [tokenSaved, setTokenSaved] = useState(false);
  const dispatch = useDispatch();

  const { handleAuth } = useUbaAuthToken();

  useEffect(() => {
    const pathParts = location.pathname.split("/").filter(Boolean);
    const tokenFromUrl = pathParts[pathParts.length - 1];

    if (!tokenFromUrl) return;

    dispatch(setUbaToken({ tokenFromUrl }));
    onAuthStateChange(true);
    setTokenSaved(true);
  }, []);

  useEffect(() => {
    if (tokenSaved) {
      handleAuth();
    }
  }, [tokenSaved]);

  return (
    <div style={containerStyle}>
      <div className="spinner"></div>
      <p style={textStyle}>Redirecting...</p>

      <style>{`
        .spinner {
          width: 40px;
          height: 40px;
          border: 4px solid #ccc;
          border-top: 4px solid #007bff;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

const containerStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
  gap: "12px",
};

const textStyle = {
  fontSize: "1.2rem",
  fontWeight: "500",
  color: "#444",
};

export default AuthRedirect;
